import formatNumber from 'lib/formatters/formatNumber';

export default formatNumber;
